import { useState } from "react";
import { Button, TextField, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { MAX_MESSAGE_LENGTH } from "models/Comment";
import { useCreateInternalCommentMutation } from "app/api/checklists";
import { Clear, Send } from "@mui/icons-material";
import LargeDialog from "components/LargeDialog";

type AddCommentDialogProps = { checklistId: string; onClose: () => void };

const AddCommentDialog: React.FC<AddCommentDialogProps> = (props) => {
  const { checklistId, onClose } = props;
  const [commentText, setCommentText] = useState("");
  const [addInternalComment, { isLoading }] = useCreateInternalCommentMutation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCommentText(event.target.value.slice(0, MAX_MESSAGE_LENGTH));
  };

  const handleSave = async () => {
    addInternalComment({
      message: commentText,
      listId: checklistId,
    })
      .unwrap()
      .then(() => onClose())
      .catch((error) => {
        console.error(error);
        toast.error("Kunde inte lägga till kommentaren. Försök igen senare.");
      });
  };

  return (
    <LargeDialog
      title="Lägg till ny kommentar"
      onClose={onClose}
      actions={
        <>
          <Button variant="outlined" disabled={isLoading} startIcon={<Clear />} onClick={onClose}>
            Avbryt
          </Button>
          <Button variant="contained" loading={isLoading} startIcon={<Send />} onClick={handleSave}>
            Skicka
          </Button>
        </>
      }
    >
      <TextField
        type="text"
        variant="filled"
        label="Meddelande"
        autoFocus
        fullWidth
        value={commentText}
        multiline
        rows={4}
        onChange={handleChange}
      />

      <Typography
        fontSize="small"
        color={commentText.length < MAX_MESSAGE_LENGTH ? "textSecondary" : "error"}
        textAlign="right"
        mt={1}
      >
        {commentText.length} / {MAX_MESSAGE_LENGTH} tecken
      </Typography>
    </LargeDialog>
  );
};

export default AddCommentDialog;
